import styled, { createGlobalStyle } from 'styled-components';
import { PageGlobalStyleMixin } from '../../mixins/components/PageGlobalStyleMixin';
import { PageMixin } from '../../mixins/components/PageMixin';
export var PageGlobalStyle = /*#__PURE__*/createGlobalStyle(["", ""], PageGlobalStyleMixin);
export var StyledPage = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPage",
  componentId: "c11n-8-111-1__sc-tzx3f5-0"
})(["", ""], PageMixin);